import { shareColumnsExtend, shareFormColumnsExtend } from '../share';

const entityColumns = {
  id: {
    model_name: 'Walk::Club',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Walk::Club',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Walk::Club',
    column_type: 'datetime',
  },
  name: {
    model_name: 'Walk::Club',
    column_type: 'string',
  },
  creator_type: {
    model_name: 'Walk::Club',
    column_type: 'string',
  },
  logo: {
    model_name: 'Walk::Club',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  logo_with_audio: {
    model_name: 'Walk::Club',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 5,
    },
  },
  introduction: {
    model_name: 'Walk::Club',
    column_type: 'text',
  },
  detail_image: {
    model_name: 'Walk::Club',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  detail_image_with_audio: {
    model_name: 'Walk::Club',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 5,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
